export const formatDataAttribute = (attribute: string): string => {
    return attribute.replace(/\s/gi, '-');
};
